import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from "next";
import { ParsedUrlQuery } from "querystring";
import SiteChrome from "@chrome/SiteChrome";
import { HtmlPageTitle } from "@components/HtmlPageTitle";
import { MetaDescription } from "@components/MetaDescription";
import Webinar from "@components/webinars/Webinar";
import WebinarPage from "@components/webinars/WebinarPage";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";
import webinarData from "@content/en/webinars/webinars.yaml";
import { stringToURI } from "@scripts/utils";

const { webinars } = webinarData;

interface WebinarPageProps {
  webinar: Webinar;
}

const WebinarLandingPage = ({ webinar }: WebinarPageProps) => (
  <>
    <SiteChrome>
      <HtmlPageTitle title={`${webinar.title} - ${SiteHtmlPageTitle}`} />
      <MetaDescription description={webinar.shortDescription} />
      <WebinarPage webinar={webinar} />
    </SiteChrome>
  </>
);

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = webinars.map((webinar) => ({
    params: {
      slug: stringToURI(webinar.title),
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

interface Params extends ParsedUrlQuery {
  slug: string;
}

export const getStaticProps: GetStaticProps = async ({
  params,
}: GetStaticPropsContext) => {
  const { slug } = params as Params;
  const webinar = webinars.filter((w) => stringToURI(w.title) === slug)[0];

  return {
    props: {
      webinar,
    },
  };
};

export default WebinarLandingPage;
